import { render, staticRenderFns } from "./WorkFlowBuilder.vue?vue&type=template&id=54274556&scoped=true"
import script from "./WorkFlowBuilder.vue?vue&type=script&lang=js"
export * from "./WorkFlowBuilder.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowBuilder.vue?vue&type=style&index=0&id=54274556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54274556",
  null
  
)

export default component.exports